<script lang="ts" module>
  import type { Snippet } from "svelte"

  export type TooltipPortalProps = {
    container?: string | HTMLElement
    children?: Snippet
  }
</script>

<script lang="ts">
  import { Portal } from "#lib/internal/components"
  import { getTooltipRootContext } from "./TooltipRoot.svelte"

  interface Props {
    container?: string | HTMLElement
    children?: Snippet
    [key: string]: any
  }

  let { container = "body", children, ...rest }: Props = $props()

  const ctx = getTooltipRootContext()
</script>

{#if ctx.open}
  <Portal target={container} {...rest}>
    {@render children?.()}
  </Portal>
{/if}
